import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UserInterface} from "../../models/user.interface";
import {StorageService} from "../../services/storage.service";
import {AppHelper} from "../../helpers/app.helper";
import {Store} from "@ngxs/store";
import {AppStateInterface} from "../../models/app-state.interface";
import {UserAction} from "../../actions/user-action";
import ChangeDarkMode = UserAction.ChangeDarkMode;
import {Subscription} from "rxjs";
import {AppState} from "../../states/app.state";
import {RequestService} from "../../services/request.service";
import {PriceUpdateService} from "../../services/price-update.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  notifying = true;

  notifyStopped = false;

  _logged = false;

  darkMode = false;

  @Input()
  user: UserInterface;

  @Output()
  onLogout = new EventEmitter();

  subscription: Subscription;

  interval: { value: number, name: string };

  timeOptions = [
    { value: 1, name: '1s' },
    { value: 2, name: '2s' },
    { value: 3, name: '3s' },
    { value: 5, name: '5s' },
    { value: 10, name: '10s' },
    { value: 15, name: '15s' },
    { value: 30, name: '30s' },
    { value: 60, name: '1min' }
  ];

  @Input()
  set logged(value) {

    this._logged = value;
  };

  get logged(){

    return this._logged;
  }

  constructor(private store: Store,
             private storageService: StorageService,
             private priceUpdateService: PriceUpdateService,
             private  requestService: RequestService) { }

  ngOnInit(): void {

    this.subscription = this.store.select(AppState.darkMode).subscribe(mode => this.darkMode = mode);
    this.animateNotify();

    this.interval = this.timeOptions.find(o => o.value === this.priceUpdateService.interval);
    //this.updateInterval() 
   // console.log('set iinterval');
   // this.priceUpdateService.interval = 60;
  }


  updateInterval() {
    this.priceUpdateService.interval = this.interval.value;
  }

  async animateNotify() {

    await AppHelper.Wait(3000);

    this.notifying = !this.notifying;

    this.animateNotify();
  }

  async changeDarkMode() {

    const appData = this.store.selectSnapshot<AppStateInterface>( state => state.appData);

    await this.requestService.put('user_config', { params: {
        id: appData.configId,
        darkmode: this.darkMode
    }, hideLoading: true })

    this.store.dispatch(new ChangeDarkMode(this.darkMode));
  }

  async logout() {

    this.notifying = false;
    this.notifyStopped = false;
    await this.storageService.logout();
    this.logged = false;
    this.onLogout.emit();
  }

  ngOnDestroy(): void {

    this.subscription?.unsubscribe();
  }

}
